import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

interface SEOProps {
    title: string;
    description: string;
}

export const useSEO = ({ title, description }: SEOProps) => {
    const { i18n } = useTranslation();

    useEffect(() => {
        // Set HTML lang attribute
        document.documentElement.lang = i18n.language;

        // 1. Update Title
        document.title = title;

        // 2. Update Meta Description
        const metaDescriptionTag = document.querySelector('meta[name="description"]');
        if (metaDescriptionTag) {
            metaDescriptionTag.setAttribute('content', description);
        } else {
            // If it doesn't exist, create it (fallback)
            const meta = document.createElement('meta');
            meta.name = 'description';
            meta.content = description;
            document.head.appendChild(meta);
        }

        // 3. Update Open Graph Meta tags (optional, useful for social sharing)
        const ogTitleTag = document.querySelector('meta[property="og:title"]');
        if (ogTitleTag) ogTitleTag.setAttribute('content', title);

        const ogDescriptionTag = document.querySelector('meta[property="og:description"]');
        if (ogDescriptionTag) ogDescriptionTag.setAttribute('content', description);

    }, [title, description, i18n.language]);
};
